import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

//------------------------------------------------------------------------------

const Option = ({ children, className, active, tabIndex, onClick }) => {
  const classNameRoot = classNames(
    'Option',
    { 'Option--active': active },
    className,
  );
  return (
    <button
      type="button"
      className={classNameRoot}
      tabIndex={tabIndex}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

Option.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  active: PropTypes.bool,
  tabIndex: PropTypes.string,
  onClick: PropTypes.func,
};

Option.defaultProps = {
  className: null,
  active: false,
  tabIndex: null,
  onClick: null,
};

export default Option;



// WEBPACK FOOTER //
// ./src/components/Form/Field/Select/Option/index.js